import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=c212f496"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=c212f496&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports